// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2hzwS","avatar":"style_avatar__3KMwG","avatarDark":"style_avatarDark__2PiH3"};